import { useEffect, useRef } from 'react';

/**
 * Run `handler` on ⌘<key> (macOS) or Ctrl-<key> anywhere in the app (M286 settings search: ⌘K / Ctrl-K). The key
 * is matched case-insensitively, the browser's own binding for it is prevented, and a held-down key fires once.
 */
export function useGlobalShortcut(key: string, handler: () => void): void {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (!(e.metaKey || e.ctrlKey) || e.altKey || e.shiftKey || e.key.toLowerCase() !== key.toLowerCase()) return;
      e.preventDefault();
      if (!e.repeat) handlerRef.current();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [key]);
}
